export default __webpack_public_path__ + "static/logo-propdata-black-46944f00bc92f78a17d5801ecbef3612.png";